import { atom } from 'recoil'

export const pageState = atom({
  key: 'EmailContentDefaultsPageState',
  default: {
    loaded: false,
    loading: false,
    error: false,
    severity: 'danger',
    isDirty: false,
    isEnabled: true
  }
})

export const customStyleState = atom({
  key: 'EmailContentCustomStyleState',
  default: {
    enabledAll: false
  }
})

export const defaultStyleState = atom({
  key: 'EmailContentDefaultsDefaultStyleStatee',
  default: {
    paragraph: {
      styles: {
        color: '#000000',
        fontSize: '14px',
        fontFamily: 'inherit',
        fontWeight: '400',
        lineHeight: '120%',
        textAlign: 'left',
        direction: 'ltr',
        letterSpacing: '0px',
        linkColor: '#0068a5',
        paragraphSpacing: '16px'
      },
      blockOptions: {
        paddingTop: '10px',
        paddingRight: '10px',
        paddingBottom: '10px',
        paddingLeft: '10px'
      },
      mobileStyles: {
        textAlign: 'left',
        fontSize: '14px',
        paddingTop: '10px',
        paddingRight: '10px',
        paddingBottom: '10px',
        paddingLeft: '10px'
      }
    },
    button: {
      styles: {
        color: '#ffffff',
        fontSize: '14px',
        fontFamily: 'inherit',
        fontWeight: '400',
        backgroundColor: '#3AAEE0',
        borderBottom: '0px solid transparent',
        borderLeft: '0px solid transparent',
        borderRadius: '4px',
        borderRight: '0px solid transparent',
        borderTop: '0px solid transparent',
        lineHeight: '200%',
        paddingBottom: '5px',
        paddingLeft: '20px',
        paddingRight: '20px',
        paddingTop: '5px'
      },
      blockOptions: {
        paddingBottom: '10px',
        paddingLeft: '10px',
        paddingRight: '10px',
        paddingTop: '10px',
        align: 'center'
      },
      mobileStyles: {
        paddingBottom: '10px',
        paddingLeft: '10px',
        paddingRight: '10px',
        paddingTop: '10px',
        textAlign: 'center',
        fontSize: '14px'
      }
    },
    social: {
      icons: [
        {
          type: 'circle-color',
          name: 'Facebook',
          image: {
            prefix: 'https://www.facebook.com/',
            alt: 'Facebook',
            src:
              'https://app-rsrc.getbee.io/public/resources/social-networks-icon-sets/circle-color/facebook@2x.png',
            title: 'Facebook',
            href: 'https://www.facebook.com/'
          },
          text: ''
        },
        {
          type: 'circle-color',
          name: 'Twitter',
          image: {
            prefix: 'https://twitter.com/',
            alt: 'Twitter',
            src:
              'https://app-rsrc.getbee.io/public/resources/social-networks-icon-sets/circle-color/twitter@2x.png',
            title: 'Twitter',
            href: 'https://twitter.com/'
          },
          text: ''
        },
        {
          type: 'circle-color',
          name: 'Instagram',
          image: {
            prefix: 'https://instagram.com/',
            alt: 'Instagram',
            src:
              'https://app-rsrc.getbee.io/public/resources/social-networks-icon-sets/circle-color/instagram@2x.png',
            title: 'Instagram',
            href: 'https://instagram.com/'
          },
          text: ''
        },
        {
          type: 'circle-color',
          name: 'Linkedin',
          image: {
            prefix: 'https://www.linkedin.com/',
            alt: 'Linkedin',
            src:
              'https://app-rsrc.getbee.io/public/resources/social-networks-icon-sets/circle-color/linkedin@2x.png',
            title: 'Linkedin',
            href: 'https://www.linkedin.com/'
          },
          text: ''
        }
      ],
      blockOptions: {
        paddingBottom: '10px',
        paddingLeft: '10px',
        paddingRight: '10px',
        paddingTop: '10px',
        align: 'center'
      },
      mobileStyles: {
        textAlign: 'center',
        paddingTop: '10px',
        paddingRight: '10px',
        paddingBottom: '10px',
        paddingLeft: '10px'
      }
    }
  }
})

export const styleState = atom({
  key: 'EmailContentDefaultsStyleStatee',
  default: {
    paragraph: {
      styles: {
        color: '',
        fontSize: '',
        fontFamily: '',
        fontWeight: '',
        lineHeight: '',
        textAlign: '',
        direction: '',
        letterSpacing: '',
        linkColor: '',
        paragraphSpacing: ''
      },
      blockOptions: {
        paddingTop: '',
        paddingRight: '',
        paddingBottom: '',
        paddingLeft: ''
      },
      mobileStyles: {
        textAlign: '',
        fontSize: '',
        paddingTop: '',
        paddingRight: '',
        paddingBottom: '',
        paddingLeft: ''
      }
    },
    button: {
      styles: {
        color: '',
        fontSize: '',
        fontFamily: '',
        fontWeight: '',
        backgroundColor: '',
        borderBottom: '',
        borderLeft: '',
        borderRadius: '',
        borderRight: '',
        borderTop: '',
        lineHeight: '',
        paddingBottom: '',
        paddingLeft: '',
        paddingRight: '',
        paddingTop: ''
      },
      blockOptions: {
        paddingBottom: '',
        paddingLeft: '',
        paddingRight: '',
        paddingTop: '',
        align: ''
      },
      mobileStyles: {
        paddingBottom: '',
        paddingLeft: '',
        paddingRight: '',
        paddingTop: '',
        textAlign: '',
        fontSize: ''
      }
    },
    social: {
      icons: [],
      blockOptions: {
        paddingBottom: '',
        paddingLeft: '',
        paddingRight: '',
        paddingTop: '',
        align: ''
      },
      mobileStyles: {
        textAlign: '',
        paddingTop: '',
        paddingRight: '',
        paddingBottom: '',
        paddingLeft: ''
      }
    }
  }
})

export const advancedPaddingState = atom({
  key: 'EmailContentDefaultsPageState_advancedPaddingState',
  default: {
    buttonDesktopPaddingAdvanced: false,
    buttonDesktopBlockAdvanced: false,
    buttonMobilePaddingAdvanced: false,
    paragraphDesktopPaddingAdvanced: false,
    paragraphMobilePaddingAdvanced: false,
    socialDesktopPaddingAdvanced: false,
    socialMobilePaddingAdvanced: false
  }
})

export const modalConfirmDiscardState = atom({
  key: 'EmailContentDefaultsPageState_modalConfirmDiscardState',
  default: {
    show: false
  }
})
